module.exports = "<lsp-img lsp-img=\"$ctrl.imageUrl\"\r\n         css-class=\"lsp-image\"></lsp-img>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/file-preview/components/file-preview-image/file-preview-image.html
// module id = 1904
// module chunks = 0